<template>
  <v-row>
    <v-col
      v-for="(item, i) in tabs"
      :key="i"
      cols="auto"
    >
      <v-btn
        :text="!tab_selected(item)"
        :to="`/print/${item.id}`"
      >
        <v-icon
          v-if="show_alert(item) && !tab_selected(item)"
          small
          color="error"
          class="mr-1"
        >
          fiber_manual_record
        </v-icon>
        {{ item.name }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'PrintHeader',
  components: {},
  data() {
    return { loading: false, saving: false };
  },
  computed: {
    tabs() {
      return this.$enums.PRINT_TABS;
    },
    id() {
      return this.$route.params.id;
    },
    show_alert() {
      return (item) => {
        switch (item.id) {
          case 'stocks':
            return !!this.stocks.filter((x) => !x.displayName).length;
          case 'finishes':
            return !!this.finishes.filter((x) => !x.displayName).length;
          case 'materials':
            return !!this.materials.filter((x) => !x.displayName).length;
          case 'categorymaterials':
            return !!this.category_materials.filter((x) => !x.text).length;
        }
        return false;
      };
    },
    tab_selected() {
      return (item) => {
        return this.id === item.id;
      };
    },
    ...mapGetters({
      stocks: 'print/stocks',
      finishes: 'print/finishes',
      materials: 'print/materials',
      category_materials: 'print/category_materials'
    })
  },
  methods: {}
};
</script>
